// extracted by mini-css-extract-plugin
export default {"authorFilterButton":"ListAuthorFilter-module__authorFilterButton--VTo2Y"};